import styled from '@emotion/styled'

export const Heading = styled.div`
  font-family: Satoshi;
  font-weight: 700;
  font-size: 40px;
  line-height: 48px;
  letter-spacing: 0%;
  text-align: center;
`
